import type { PluginListenerHandle } from '@capacitor/core'
import { Capacitor } from '@capacitor/core'
import type { ConnectionStatus } from '@capacitor/network'
import { Network } from '@capacitor/network'
import { makeConnectionStatus } from './makeConnectionStatus'

export const addNetworkStatusListener = (
  listener: (status: ConnectionStatus) => void,
): Promise<PluginListenerHandle> => {
  if (Capacitor.isNativePlatform()) return Network.addListener('networkStatusChange', listener)

  const handleOnline = () => listener(makeConnectionStatus(true))
  const handleOffline = () => listener(makeConnectionStatus(false))

  window.addEventListener('online', handleOnline)

  window.addEventListener('offline', handleOffline)

  return Promise.resolve({
    remove: async () => {
      window.removeEventListener('online', handleOnline)

      window.removeEventListener('offline', handleOffline)
    },
  })
}
